import React from 'react';
import PartialFeatures from '../partials/twb_features';
import { getImageTransform } from '~/utils/helpers';
import PartialText from '../partials/twb_text';
import { graphql } from 'gatsby';

interface LargeCardProps {
  block: {
    _template: string;
    css_class_name?: string;
    container_width?: string;
    settings: Settings;
    title: string;
    text: string;
    image_position: string;
    image_field: ImageField<RegularImage>[];
    items: LargeCardItem[];
  };
  vars: { [key: string]: string };
}

export const LargeCardItems = ({ block, vars }: LargeCardProps) => {
  const [image] = block.image_field;
  let default_width = block.image_position === 'left' ? 'col-lg-7' : 'col-lg-6';
  let default_offset = block.image_position === 'left' ? 'offset-lg-5' : '';
  const imageStyleOverride = getImageTransform(image);
  const cssClassName = block.css_class_name ? block.css_class_name : '';
  const sectionWidthClass =
    block.container_width === 'full' ? 'full-width' : '';
  const nestingWidthClass =
    block.container_width === 'full' ? 'col-12' : default_width;
  const nestingOffsetClass =
    block.image_position === 'left' ? default_offset : '';
  const imageStyle =
    block.image_position === 'left'
      ? {
          left: '-8rem',
          right: 'unset',
          transform: 'scaleX(-1)',
        }
      : {};

  return (
    <section
      className={`block block__large_card ${cssClassName} ${sectionWidthClass}`}
    >
      <div className='container'>
        <div className='card'>
          <div className='row'>
            <div className={`${nestingWidthClass} ${nestingOffsetClass}`}>
              <PartialText
                block={{
                  _template: 'partial__text',
                  list_columns: '1',
                  title: block.title,
                  text: block.text,
                }}
              />

              <PartialFeatures
                block={{
                  _template: 'partial__features',
                  list_columns: '',
                  items: block.items,
                }}
              />
            </div>
          </div>

          {image && (
            <img
              className='card-image'
              src={image.src}
              alt={image.alt}
              title={image.alt}
              style={imageStyle}
            />
          )}
        </div>
      </div>
    </section>
  );
};

export const largeCardItemFragment = graphql`
  fragment LargeCardItemFragment on Item {
    title
    subtitle
    icon
    icon_position
  }
`;

export const largeCardItemsFragment = graphql`
  fragment LargeCardItemsFragment on Block {
    _template
    settings {
      ...SettingsFragment
    }
    container_width
    title
    description
    image_position
    image_field {
      ...ImageFieldFragment
    }
    items {
      ...LargeCardItemFragment
    }
  }
`;
